import React from "react";
import "./App.css";
import CallApi from "./screens/CallApi";
import Home from "./screens/Home";
import TikTakToe from "./screens/TikTakToe";

const App: React.FC = (props) => {  

  return (
      <TikTakToe />
      // <CallApi />
      // <Home />
      
     
  );
};

export default App;
